const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

const randomSuffix = (length: number) => {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let out = "";
  for (const byte of bytes) out += ALPHABET[byte % ALPHABET.length];
  return out;
};

const sequence = globalThis as typeof globalThis & {
  __northstarChatSeq?: { at: number; count: number };
};

sequence.__northstarChatSeq ??= { at: 0, count: 0 };

export const createMessageId = () => {
  const now = Date.now();
  const state = sequence.__northstarChatSeq as { at: number; count: number };
  if (now === state.at) state.count += 1;
  else {
    state.at = now;
    state.count = 0;
  }
  const stamp = now.toString(36).padStart(9, "0");
  const ordinal = state.count.toString(36).padStart(4, "0");
  return `${stamp}${ordinal}${randomSuffix(4)}`;
};

const CLIENT_ID = /^c[0-9a-z]{16}$/;

export const createClientId = () => `c${randomSuffix(16)}`;

export const isClientId = (value: unknown): value is string =>
  typeof value === "string" && CLIENT_ID.test(value);
